import * as React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

const copy = require('copy-to-clipboard');

export interface Iprops {
  open: boolean;
  handleClose: () => void;
  type: string;
  campaignType: string;
  id: string;
}

interface State {
  googleAmp: boolean;
  open: boolean;
}

export default class DeleteDialog extends React.Component<Iprops, State> {

  constructor(props) {
    super(props);
    this.state= {
      open: false,
      googleAmp: false
    }
  }

  get ampWidgetCode(){
    const {id} = this.props;
    return `<amp-iframe id="donaco-widget"
      width="auto"
      height="493px"
      layout="fixed-height"
      resizable
      src="https://donaco-widget-staging.firebaseapp.com/app.html?id=${id}"
      frameborder="0"
      scrolling="no"
      sandbox="allow-scripts allow-same-origin"
      style="display:block;">
      <div overflow>...</div>
    </amp-iframe>`;
  }

  get widgetCode(){
    const {type, id} = this.props;

    return  type && type.includes('float')?
    `<div class="d-popover-wrapper">
    <button onclick={document.getElementById("dWidgetPopOver").classList.toggle('d-popover-content-active')} class="d-floating-btn">
      <h2 style="color: #ffffff; font-weight: normal">DONATE</h2>
    </button>
    <div class="d-popover-content" id="dWidgetPopOver">
      <iframe id="donaco-widget-float"
        name="${id}"
        width="100%"
        height="493px"
        src="https://donaco-widget-staging.firebaseapp.com/app.html"
        frameborder="0"
        scrolling="no"
        style="border: none;display:block;">
      </iframe>
      <link rel="stylesheet" type="text/css" href="https://donaco-widget-static-10175.firebaseapp.com/dWidget.css"/>
      <script> window.frames['${id}'].postMessage('message', '*'); </script>
    </div>
    </div>`:
    `<iframe id="donaco-widget-inline"
    name="${id}"
    width="100%"
    height="493px"
    src="https://donaco-widget-staging.firebaseapp.com/app.html"
    frameborder="0"
    scrolling="no"
    style="display:block;">
  </iframe>${type && type.includes('tagline') 
  ? `
  <script>window.frames['${id}'].postMessage('message', '*');</script>
  <script src="https://donaco-widget-static-10175.firebaseapp.com/dWidget.js"></script>`
  : ''
  }`
    
  }

  render() {
    const { open, handleClose, type, id, campaignType } = this.props;
    const code = this.state.googleAmp ? this.ampWidgetCode : this.widgetCode;

    return(
      <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">Widget Code</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Please copy following code
            </DialogContentText>
            <pre style={{ fontSize: 14, lineHeight: 1.5, marginTop: 15 }}>
              {code}
            </pre>
          </DialogContent>
          <DialogActions>
            {(campaignType === 'fundraisingPack' || 
            (campaignType === 'donation' && 
              !type.includes('float') && 
              !type.includes('tagline')
            )) &&
              <FormControlLabel
                control={
                  <Checkbox 
                    checked={this.state.googleAmp} 
                    onClick={() => this.setState((state) => ({ googleAmp: !state.googleAmp }))} 
                  />
                }
                style={{ fontSize: '16px'}}
                label="Google Amp"
              />
            }
            
            <Button onClick={() => copy(code)}>
              Copy to clipboard
            </Button>
            <Button onClick={handleClose}>
              OK
            </Button>
          </DialogActions>
        </Dialog>
    )
  }
}